import { Stack } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';

interface Props {
	title1: string;
	title2?: string;
	subtitle1?: string;
	subtitle2?: string;
	link?: string;
	index?: number;
	clearSearch?: () => void;
}

const SearchCard = (props: Props) => {
	const { title1, title2, subtitle1, subtitle2 } = props;

	return (
		<Stack
			justifyContent='space-between'
			direction='row'
			sx={{ width: '100%' }}
		>
			<ListItemText
				primary={!!title1 ? title1 : <>&nbsp;</>}
				primaryTypographyProps={{ sx: { textTransform: 'capitalize' } }}
				secondary={!!subtitle1 ? subtitle1 : <>&nbsp;</>}
				sx={{ textAlign: 'left' }}
			/>
			<ListItemText
				primary={!!title2 ? title2 : <>&nbsp;</>}
				secondary={!!subtitle2 ? subtitle2 : <>&nbsp;</>}
				sx={{ textAlign: 'right' }}
			/>
		</Stack>
	);
};

export default SearchCard;
